import { createRouter, createWebHistory } from 'vue-router'
import projects from '@/views/projects.vue'
import login from '@/views/login.vue'
import MainLayout from '@/layout/main_layout.vue'
import Units from '@/views/units.vue'
import developers from '@/views/developers.vue'
import Users from '@/views/users.vue'
import Requests from '@/views/requests.vue'
import Profile from '@/views/profile.vue'
import Leads from '@/views/leads.vue'
import Offers from '@/views/offers.vue'
import Settings from '@/views/settings.vue'
const routes = [
  {
    path:'/login',
    name:'login',
    component:login,
  },
  {
    path: "/",
    redirect: '/units',
    name:"home",
    component: MainLayout,
    meta: {
      requiresAuth: true,
    },
    children:[
      {
        path:'users',
        name:'users',
        component:Users,
      },
      {
        path: 'units/:userId?',
        name: 'units',
        component: Units,
        props: true,  // This will pass the route parameters as props to the component
      },
      {
        path: 'projects',
        name: 'projects',
        component: projects,
      },
      {
        path: 'developers',
        name: 'developers',
        component: developers,
      },
      {
        path: 'offers',
        name: 'TodaysOffers',
        component: Offers,
      },
      {
        path: 'requests',
        name: 'requests',
        component: Requests,
      },
      {
        path: 'profile/:userId?',
        name: 'profile',
        component: Profile,
        props: true,
      },
      {
        path: 'leads',
        name: 'leads',
        component: Leads,
      },
      {
        path: 'settings',
        name: 'settings',
        component: Settings,
      },
    ]
  },
  

]

const router = createRouter({
  history: createWebHistory(), // Replace with '/' if BASE_URL is not defined
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next("/");
  }

  const isAuthenticated = localStorage.getItem('authToken');
  const userCrmRole = localStorage.getItem('crm_role');
  const userId = localStorage.getItem('id');

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: 'login' });
    } else {
      // التحقق من محاولة دخول المستخدم إلى صفحة الملف الشخصي
      if (to.name === 'profile' && userCrmRole == 'Sales') {
        if (to.params.userId !== userId) {
          return next({ name: 'profile', params: { userId } });
        }
      }
      next();
    }
  } else {
    next();
  }
});




export default router
